<template>
    <div class="chat-test" v-if="settings.iframe_link || settings.direct_line">
        <div class="chat-test-header pa-1 primary">
            <v-layout row align-center>
                <v-flex xs6>
                    <img src="../../assets/logo.png" alt="" class="botter-preview-logo mt-1" width="40">
                </v-flex>
                <v-flex xs6 class="text-xs-right">
                    <v-icon @click="$emit('closeChat')" color="white">close</v-icon>
                </v-flex>
            </v-layout>
        </div>
        <div class="chat-test-body white">
            <iframe v-if="settings.iframe_link" class="iframe-box"
                    :src="settings.iframe_link" width="100%" height="100%" frameborder="0"></iframe>
            <iframe v-else class="iframe-box"
                    :src="`https://testing-webchat.botter.live/?s=${settings.direct_line}&bing=${settings.bing_subscription_key}`" width="100%" height="100%" frameborder="0"></iframe>
        </div>
    </div>
</template>


<script>
    import common from "../../utils/common";
    export default {
        name: "preview",
        data() {
          return {
            settings: {}
          }
        },
        mounted() {
            this.getSettings()
        },
        methods: {
            getSettings() {
                this.$http_bot.get('/settings/')
                    .then(response=>{
                        this.settings = response.data
                    })
                    .catch(error=>{
                        if (error.response.status === 401) {
                            common.logOut()
                        }
                    })
            },
        }
    }
</script>



<style scoped>

</style>